import {
  Identifiable,
  Resource,
  Notification,
  NotificationsFilter,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getNotifications(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>, filter: NotificationsFilter) => {
    const typeFilter =
      filter.types && filter.types.length > 0
        ? ` and notification.type=in=(${filter.types.map((t) => `'${t}'`).join(",")})`
        : "";

    return httpClient
      .sendHttpRequest<{
        _embedded: {
          resourceNotifications: {
            uuid: string;
            notification: Identifiable<Notification>;
            read: boolean;
          }[];
        };
        page: {
          size: number;
          totalElements: number;
          totalPages: number;
          number: number;
        };
      }>({
        endpoint: `/resourceNotifications/search/rsql?query=resource.uuid=='${resource.uuid}'${typeFilter}&page=${filter.start}&size=${filter.limit}&projection=details`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded, page }) => ({
        totalPages: page.totalPages || 1,
        notifications: _embedded
          ? _embedded.resourceNotifications.map(
              ({ notification, read, uuid }) => ({
                ...notification,
                uuid,
                isRead: read,
              }),
            )
          : [],
      }));
  };
}

export { getNotifications };
